<template>
  <ul class="pl-0">
    <p>თანამონაწილეები:</p>
    <li v-for="(user, i) in users" :key="user.id">
      <span
        v-if="user.data.finished"
        class="name status"
        :class="{'online' : user.data.active, 'offline' : !user.data.active}"
      >{{user.name}} საბოლოო შედეგი: {{user.data.score}} ქულა</span>
      <span v-else>
        <span
          class="name status"
          :class="{'online' : user.data.active, 'offline' : !user.data.active}"
        >{{ (i + 1) }}) {{user.name}}</span>
        <br />
        ქულა: {{user.data.score}}
        <br />
        შეკითხვა: {{ (user.data.current + 1) }}
      </span>
      <hr />
    </li>
  </ul>
</template>

<script>
export default {
  props: ["quizroom", "participants"],
  data() {
    return {
      users: []
    };
  },
  methods: {
    sortUsers() {
      this.users.sort((a, b) => b.data.score - a.data.score);
    },
    addParticipants() {
      axios
        .post(`/quizroom/addparticipants/${this.quizroom.code}`)
        .then(res => console.log(res))
        .catch(err => console.log(err));
    },
    x(data) {
      axios
        .post(`/quizroom/data/${this.quizroom.code}`, data)
        .then(res => console.log(res))
        .catch(err => console.log(err));
    },
    // add users which is not active right know
    fillUsers() {
      this.participants.map(p => {
        const check = this.users.filter(f => f.id == p.id);
        if (check.length == 0) {
          // p.data =  {score: 0, current: 0, finished: false, active:false}
          this.users.push(p);
        }
      });
      this.sortUsers();
    }
  },
  mounted() {
    window.bus.$on("nextQuestion", message => {
      // add data to local user
      this.users.map(u =>
        u.id == window.App.user.id ? (u.data = message) : ""
      );
      message.active = true;
      this.sortUsers();
      window.Echo.join("quizroom." + this.quizroom.code).whisper("next", {
        data: message,
        user: window.App.user
      });
      this.x(message);
    });

    window.Echo.join("quizroom." + this.quizroom.code)
      .here(user => {
        user.map(u => {
          u.user.data = { score: 0, current: 0, finished: false, active: true };
          this.users.push(u.user);
        });
        this.fillUsers();
      })
      .joining(event => {
        let check = this.users.filter(u => u.id == event.user.id);
        if (check.length > 0) {
          check[0].data.active = true;
        } else {
          event.user.data = {
            score: 0,
            current: 0,
            finished: false,
            active: true
          };
          this.users.push(event.user);
        }
      })
      .leaving(event => {
        this.users.map(user => {
          if (user.id == event.user.id) {
            user.data.active = false;
          }
        });
      })
      .listenForWhisper("next", event => {
        this.users.map(user => {
          if (user.id == event.user.id) {
            user.data = event.data;
          }
        });
        this.sortUsers();
      });

    this.addParticipants();
  }
};
</script>

<style scoped>
ul li {
  list-style: none;
}

span.status {
  position: relative;
  padding-left: 12px;
}
span.status::after {
  content: "";
  position: absolute;
  top: 4px;
  left: -2px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
}
span.online::after {
  background: green;
}
span.offline::after {
  background: red;
}
</style>
